// extracted by mini-css-extract-plugin
export default {"move":"Safety_move__Lb1uS","slideUp":"Safety_slideUp__ujWM5","btn":"Safety_btn__c9fhX","link_privacy":"Safety_link_privacy__F2-11"};